import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useStore';
import PostContent from 'presenters/Post/PostContent';
import PostExtra from 'presenters/Post/PostExtra';
import { Box } from '@mui/material';
import useCustomParam from 'hooks/useCustomParam';
import TeacherPostReviewDetailStore from './TeacherPostReviewDetailStore';
import { TeacherPostReviewDetailPropsT } from './TeacherPostReviewDetail';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PostHeader from 'presenters/Post/PostHeader';
import { PostTypeT } from 'types/shared/core/Post';
import PostReviewActions from './PostReviewActions';

const TeacherPostReviewDetailContainer = observer(
  ({ scope }: TeacherPostReviewDetailPropsT) => {
    const { init, post, handlePersonalMessageClick, handlePostCornerAction } =
      useStore<TeacherPostReviewDetailStore>('TeacherPostReviewDetailStore');

    const postType = useCustomParam<PostTypeT>(
      'postType',
      'param',
      'string',
      null,
    );
    const postId = useCustomParam<number>(
      'postId', //
      'param',
      'number',
      null,
    );

    useEffect(() => {
      console.log('useEffect fired', postType, postId);
      if (postType !== 'notePost' && postType !== 'boardPost') return;
      postType && postId && init(scope, postType, postId);
    }, [scope, postType, postId]);

    if (!post) {
      return null;
    }

    const isTransparent = !post.isVisible;

    const customActionComponent: React.ComponentType<{}> | undefined =
      scope === 'inbox' ? PostReviewActions : undefined;

    return (
      <Box pb={8} sx={{ opacity: isTransparent ? '50%' : 'inherit' }}>
        <PostHeader
          post={post}
          perspective="teacherSide"
          cornerActionIcon={MoreHorizIcon}
          onClickPostCornerAction={() => handlePostCornerAction(post)}
        />

        <PostContent
          post={post}
          perspective="teacherSide"
          onPersonalMessageClick={handlePersonalMessageClick}
        />

        <PostExtra
          view={post.views || 0}
          like={3}
          comment={post.comments || 0}
          isVisible={false}
          CustomActionsComponent={customActionComponent}
        />
      </Box>
    );
  },
);
export default TeacherPostReviewDetailContainer;
